module.exports = __webpack_public_path__ + "img/click_tips.356d7011.gif";